import { useQuery } from '@apollo/client';
import camelcaseKeys from 'camelcase-keys';
import checkCreditBalanceQuery from 'src/queries/checkCreditBalance.graphql';
import { useCustomerStatus } from 'src/core/state/user';
import { useEffect } from 'react';

export type CreditBalanceData = {
    creditAvailable: number | undefined;
    creditMax: number | undefined;
    loading: boolean;
};

export function useCreditBalance(skip = false): CreditBalanceData {
    const { isSignedIn } = useCustomerStatus();
    const {
        data: creditBalanceData,
        loading,
        refetch,
    } = useQuery(checkCreditBalanceQuery, {
        variables: {},
        skip,
    });

    useEffect(() => {
        if (isSignedIn && !skip) {
            refetch();
        }
    }, [isSignedIn, skip, refetch]);

    const customerData = creditBalanceData ? camelcaseKeys(creditBalanceData, { deep: true })?.customer : undefined;
    const rawCreditAvailable = customerData?.storeCredit?.currentBalance?.value;
    const rawCreditMax = customerData?.maxCreditAllowed;

    // If max credit is undefined or 0, default to available credit
    const creditMax = rawCreditMax || rawCreditAvailable;
    // If available credit is bigger than max credit, cap it to max credit
    const creditAvailable = rawCreditAvailable > creditMax ? creditMax : rawCreditAvailable;

    return {
        creditAvailable,
        creditMax,
        loading,
    };
}
